import { type FC, useEffect, useState } from 'react';
import { useFilters } from '../../../../../hooks/useFilters';
import type { Filter } from '../../../../../stores/filters';
import { StyledBIToggleButtons } from './styles';

const FilterToggleButtons: FC<{
  filterId: string;
  onToggleChange?: (value: string) => void;
}> = ({ filterId, onToggleChange }) => {
  const { filters, setFilterExpressionType } = useFilters();
  const filtersList = filters && (Object.values(filters) as Array<Filter>);
  const filter = filtersList.find((filter) => filter.filterName === filterId);
  const toggleValue = filter ? (filter.expressionType as string) : 'target';
  const [initialToggleValue, setInitialToggleValue] = useState(toggleValue);

  useEffect(() => {
    const expressionType = filters?.[filterId]?.expressionType;
    if (expressionType) setInitialToggleValue(expressionType);
  }, []);

  const handleToggleChange = (toggleValue: string | null) => {
    if (toggleValue === null) return;
    if (onToggleChange) {
      onToggleChange(toggleValue);
    } else {
      setFilterExpressionType({
        filterName: filterId,
        expressionType: toggleValue.includes('target') ? 'target' : 'block',
      });
    }
  };

  return (
    <StyledBIToggleButtons
      toggleValues={['target', 'block']}
      initialValue={initialToggleValue}
      onToggleChange={handleToggleChange}
    />
  );
};

export default FilterToggleButtons;
